import { useState, type FormEvent } from "react";
import { Link } from "@tanstack/react-router";
import { api } from "@/lib/api";
import { useOturum } from "@/lib/oturum";
import { Logo } from "@/components/logo";
import { ThemeToggle } from "@/components/theme-toggle";
import { DilSecici } from "@/components/dil-secici";
import { YuklemePerdesi } from "@/components/yukleme";
import { cevir } from "@/lib/dil";
import { useVeri } from "@/lib/veri";

/**
 * Giriş: kimlik + şifre, iki alan tek buton. Kimlik telefondur; e-postayla giriş açık ortamda (test sunucusu,
 * `ayar.eposta_giris`) aynı alana e-posta da yazılabilir. Öteki ortamlarda e-posta yalnız mail kanalı.
 */
export function Giris() {
  const { yenile } = useOturum();
  const { veri: secenek } = useVeri<{ epostaGiris: boolean }>("/auth/secenekler");
  const eposta = secenek?.epostaGiris === true;
  const [kimlik, setKimlik] = useState("");
  const [parola, setParola] = useState("");
  const [hata, setHata] = useState<string | null>(null);
  const [mesgul, setMesgul] = useState(false);

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setHata(null);
    setMesgul(true);
    try {
      // Perde bu bileşende duruyor: oturum tazelenince Giriş ekranı sökülüyor.
      // Bu yüzden bekleme `yenile()` ÖNCESİNE alındı; animasyon bir tur dönmeden ekran değişmiyor.
      const baslangic = Date.now();
      await api.post("/auth/giris", { kimlik, parola });
      const kalan = 1400 - (Date.now() - baslangic);
      if (kalan > 0) await new Promise((r) => setTimeout(r, kalan));
      await yenile();
    } catch (err) {
      setHata(err instanceof Error ? err.message : cevir("Login failed"));
    } finally {
      setMesgul(false);
    }
  }

  if (mesgul) return <YuklemePerdesi mesaj={cevir("Logging in")} />;

  return (
    <main className="flex min-h-dvh items-center justify-center bg-bg p-4 font-plex">
      <div className="absolute right-4 top-4 flex items-center gap-1.5"><DilSecici /><ThemeToggle /></div>
      <form onSubmit={gonder} className="w-full max-w-sm rounded-xl border border-line bg-surface p-6 shadow-[var(--shadow-lg)]">
        <Logo height={26} />
        <p className="mb-6 mt-2 text-base text-ink-2">{cevir("DS Yavuz riser recertification tracking")}</p>

        <label className="mb-1 block text-base font-medium text-ink-2" htmlFor="kimlik">{eposta ? cevir("Phone or email") : cevir("Phone")}</label>
        <input id="kimlik" type={eposta ? "text" : "tel"} inputMode={eposta ? "email" : "numeric"} autoComplete="username" autoFocus placeholder={eposta ? "0554 178 17 74 · name@modoffshore.com" : "0554 178 17 74"} value={kimlik} onChange={(e) => setKimlik(e.target.value)}
          className={girdi} />

        <label className="mb-1 mt-4 block text-base font-medium text-ink-2" htmlFor="parola">{cevir("Password")}</label>
        <input id="parola" type="password" autoComplete="current-password" value={parola} onChange={(e) => setParola(e.target.value)} className={girdi} />

        {hata && <p role="alert" className="mt-4 rounded-md bg-bad-bg p-3 text-base text-bad">{hata}</p>}

        <button type="submit" disabled={mesgul || !kimlik || !parola} className="mt-5 w-full rounded-md bg-navy px-4 py-2.5 font-semibold text-white disabled:opacity-40 dark:text-[#0a141c]">
          {mesgul ? cevir("Logging in...") : cevir("Login")}
        </button>
        <Link to="/sifremi-unuttum" className="mt-4 block text-center text-base text-ink-3 underline underline-offset-2 hover:text-ink">{cevir("I forgot my password")}</Link>
      </form>
    </main>
  );
}

export const girdi = "w-full rounded-md border border-line-strong bg-bg px-3 py-2.5 text-md text-ink outline-none focus:border-orange";
